import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { usePreferences } from "@/lib/preferences";

/**
 * RequireOnboarded wraps a protected route and redirects to /onboarding
 * unless the participant has completed onboarding. Admins are exempt.
 */
export function RequireOnboarded({ children }) {
  const { user, loading } = useAuth();
  const { prefs, loaded } = usePreferences();
  const location = useLocation();

  if (loading || !loaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-base text-fg-secondary">
        <span className="text-sm">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (user.role === "admin") return children;
  if (!prefs?.onboarding_completed_at) return <Navigate to="/onboarding" replace />;
  return children;
}

export default RequireOnboarded;
